document.addEventListener('turbolinks:load', function() {
  // Add required CSS
  const style = document.createElement('style');
  style.textContent = `
    .add-to-playlist {
      position: relative;
    }
    .add-to-playlist .dropdown-menu {
      display: none;
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1000;
      min-width: 10rem;
      padding: 0.5rem 0;
      margin: 0.125rem 0 0;
      background-color: #191919;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 0.25rem;
    }
    .add-to-playlist .dropdown-menu.show {
      display: block;
    }
    .add-to-playlist .dropdown-menu .dropdown-item {
      color: #ffffff;
      padding: 0.5rem 1rem;
    }
    .add-to-playlist .dropdown-menu .dropdown-item:hover,
    .add-to-playlist .dropdown-menu .dropdown-item:focus {
      background-color: #252525;
      color: #ffffff;
    }
    .add-to-playlist .dropdown-menu .dropdown-divider {
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      margin: 0.5rem 0;
    }
    .add-to-playlist .dropdown-menu .btn-link {
      color: #ffffff;
      text-decoration: none;
      width: 100%;
      text-align: left;
      padding: 0;
    }
    .add-to-playlist .dropdown-menu .btn-link:hover,
    .add-to-playlist .dropdown-menu .btn-link:focus {
      color: #ffffff;
      text-decoration: none;
    }
  `;
  document.head.appendChild(style);

  // Initialize all playlist dropdowns manually
  $('.add-to-playlist .dropdown-toggle').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const $dropdownMenu = $(this).next('.dropdown-menu');
    $('.dropdown-menu').not($dropdownMenu).removeClass('show');
    $dropdownMenu.toggleClass('show');
  });

  // Close dropdown when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.add-to-playlist').length) {
      $('.dropdown-menu').removeClass('show');
    }
  });
});
